import React, { useContext, useEffect, useState } from "react";
import { AuthContext } from "../../contexts/AuthContext";
import { Modal, ModalHeader, ModalBody } from "reactstrap";
import Password from "../Login/Password";
import {
  IcMenu, IcChevL, IcChevR, IcChevD, IcChevU,
  IcUserCircle, IcLock, IcSignOut,
} from "../../Icons";

// ── SVG base (para los iconos de nav personalizados) ──────────────────────────
const S = ({ size = 18, children, style }) => (
  <svg
    width={size} height={size} viewBox="0 0 24 24"
    fill="none" stroke="currentColor"
    strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"
    aria-hidden="true"
    style={{ flexShrink: 0, display: "inline-block", verticalAlign: "middle", ...style }}
  >
    {children}
  </svg>
);

// Modelos — etiqueta de prenda
const IcModelos = () => (
  <S>
    <path d="M20.6 7.5 16 5l-1.5 1.5a3.5 3.5 0 0 1-5 0L8 5 3.4 7.5l2 4 2-1v9h9.2v-9l2 1z"/>
  </S>
);
// Compras — carrito
const IcCompras = () => (
  <S>
    <circle cx="9" cy="20" r="1.4"/>
    <circle cx="18" cy="20" r="1.4"/>
    <path d="M2 3h3l2.5 12h11L21 7H6"/>
  </S>
);
// Ventas — billetera con flecha de entrada
const IcVentas = () => (
  <S>
    <path d="M4 7h16a2 2 0 0 1 2 2v9a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V9a2 2 0 0 1 2-2z"/>
    <path d="M16 7V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v2"/>
    <circle cx="18" cy="13" r="2" fill="currentColor" strokeWidth="0"/>
  </S>
);
// Tiendas — local con toldo
const IcTiendas = () => (
  <S>
    <path d="M3 9V7l2-4h14l2 4v2"/>
    <path d="M3 9a2.5 2.5 0 0 0 5 0 2.5 2.5 0 0 0 5 0 2.5 2.5 0 0 0 5 0 2.5 2.5 0 0 0 3 0"/>
    <path d="M4.5 11v9h15v-9"/>
    <rect x="9.5" y="14" width="5" height="6"/>
  </S>
);
// Inventarios — cajas apiladas
const IcInventarios = () => (
  <S>
    <path d="M3 8.5 12 4l9 4.5-9 4.5z"/>
    <path d="M3 8.5V16l9 4.5V13"/>
    <path d="M21 8.5V16l-9 4.5"/>
  </S>
);
// Traspasos — flechas de intercambio
const IcTraspasos = () => (
  <S>
    <polyline points="7 4 3 8 7 12"/>
    <path d="M3 8h13a4 4 0 0 1 4 4"/>
    <polyline points="17 20 21 16 17 12"/>
    <path d="M21 16H8a4 4 0 0 1-4-4"/>
  </S>
);
// Gastos — cartera/billetera con moneda
const IcGastos = () => (
  <S>
    <path d="M20 8H4a2 2 0 0 0-2 2v9a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-9a2 2 0 0 0-2-2z"/>
    <path d="M16 8V6a2 2 0 0 0-2-2H10a2 2 0 0 0-2 2v2"/>
    <path d="M22 13h-4a2 2 0 0 0 0 4h4"/>
    <circle cx="18" cy="15" r=".8" fill="currentColor" strokeWidth="0"/>
  </S>
);
// Admin — documento con línea de tendencia ascendente
const IcAdmin = () => (
  <S>
    <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/>
    <polyline points="14 2 14 8 20 8"/>
    <polyline points="7 16 10 13 13 15.5 17 11"/>
    <circle cx="17" cy="11" r="1" fill="currentColor" strokeWidth="0"/>
  </S>
);
// Fiscal — documento tipo recibo con sello en esquina
const IcFiscal = () => (
  <S>
    <path d="M4 3h16v13l-4 4H4z"/>
    <line x1="8"  y1="8"  x2="16" y2="8"/>
    <line x1="8"  y1="12" x2="16" y2="12"/>
    <line x1="8"  y1="16" x2="12" y2="16"/>
    <polyline points="16 16 16 20 20 16"/>
  </S>
);
// CxP — documento con doblez + signo $
const IcCxP = () => (
  <S>
    <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/>
    <polyline points="14 2 14 8 20 8"/>
    <line x1="12" y1="10" x2="12" y2="18"/>
    <path d="M14.5 12.5c0-1.4-1.1-2.5-2.5-2.5-1.1 0-2.5.7-2.5 2 0 1.3 1.4 2 2.5 2s2.5.7 2.5 2c0 1.3-1.4 2-2.5 2-1.4 0-2.5-1.1-2.5-2.5"/>
  </S>
);
// Reportes — barras ascendentes con línea de tendencia
const IcReportes = () => (
  <S>
    <line x1="3" y1="21" x2="21" y2="21"/>
    <rect x="4"  y="13" width="4" height="8" rx="1"/>
    <rect x="10" y="8"  width="4" height="13" rx="1"/>
    <rect x="16" y="4"  width="4" height="17" rx="1"/>
    <polyline points="5 10 10 6 15 9 20 3" strokeDasharray="1.5 1.5" strokeOpacity={0.6}/>
  </S>
);
// Empleados — grupo de personas
const IcEmpleados = () => (
  <S>
    <circle cx="9" cy="8" r="3.2"/>
    <path d="M2.5 20v-1a6.5 6.5 0 0 1 13 0v1"/>
    <path d="M17 11.2A3 3 0 1 0 17 5.3"/>
    <path d="M18 13.5a5.5 5.5 0 0 1 3.5 5.1V20"/>
  </S>
);
// WhatsApp — globo de chat
const IcWhatsApp = () => (
  <S>
    <path d="M21 11.5a8.4 8.4 0 0 1-12.6 7.3L3 20.5l1.8-5.2A8.4 8.4 0 1 1 21 11.5z"/>
  </S>
);
// Usuarios — persona con check (gestión de acceso)
const IcUsuarios = () => (
  <S>
    <circle cx="10" cy="7" r="4"/>
    <path d="M3 21v-1a7 7 0 0 1 7-7h1.5"/>
    <path d="M17 13l1 1 3-3" strokeWidth="1.8"/>
    <circle cx="19" cy="17" r="3.5"/>
  </S>
);
// Logs — portapapeles con lista de ítems
const IcLogs = () => (
  <S>
    <path d="M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2"/>
    <rect x="8" y="2" width="8" height="4" rx="1"/>
    <circle cx="9" cy="11" r="1"  fill="currentColor" strokeWidth="0"/>
    <line  x1="12" y1="11" x2="17" y2="11"/>
    <circle cx="9" cy="15.5" r="1" fill="currentColor" strokeWidth="0"/>
    <line  x1="12" y1="15.5" x2="17" y2="15.5"/>
  </S>
);

// ── Navegacion agrupada por seccion (Sauver) ─────────────────────────────────
// Los permisos (perm) son los MISMOS que usaba el Header anterior de Sauver.
const NAV_SECTIONS = [
  {
    section: "Operación",
    items: [
      { label: "Modelos",     icon: <IcModelos />,     href: "/MenuArticulos",   perm: "menu_articulos" },
      { label: "Compras",     icon: <IcCompras />,     href: "/MenuCompras",     perm: "menu_compras" },
      { label: "Ventas",      icon: <IcVentas />,      href: "/MenuVentas",      perm: "menu_ventas" },
      { label: "Tiendas",     icon: <IcTiendas />,     href: "/MenuTiendas",     perm: "menuTiendas" },
      { label: "Inventarios", icon: <IcInventarios />, href: "/MenuInventarios", perm: "menu_inventarios" },
      // { label: "Traspasos",   icon: <IcTraspasos />,   href: "/MenuTraspasos",   perm: "menu_traspasos_salida" },
    ],
  },
  {
    section: "Finanzas",
    items: [
      { label: "Gastos", icon: <IcGastos />, href: "/MenuGastos", perm: "menu_admin" },
      { label: "Admin",  icon: <IcAdmin />,  href: "/MenuAdmin",  perm: "configAdmin" },
      { label: "Fiscal", icon: <IcFiscal />, href: "/MenuFiscal", perm: "menu_fiscal" },
      { label: "CxP",    icon: <IcCxP />,    href: "/MenuCXP",    perm: "pagoProveedores" },
    ],
  },
  {
    section: "Análisis",
    items: [
      { label: "Reportes", icon: <IcReportes />, href: "/MenuReportes", perm: "menu_reportes" },
    ],
  },
  {
    section: "Administración",
    items: [
      { label: "Empleados", icon: <IcEmpleados />, href: "/MenuNominas",  perm: "menu_empleados" },
      { label: "WhatsApp",  icon: <IcWhatsApp />,  href: "/WhatsApp",     perm: "configuracion" },
      { label: "Usuarios",  icon: <IcUsuarios />,  href: "/MenuUsuarios", perm: "menu_usuarios" },
      { label: "Logs",      icon: <IcLogs />,      href: "/MenuLogs",     perm: "menu_logs" },
    ],
  },
];

const AREAS_ABY  = process.env.REACT_APP_AREAS_ABY;
const AREAS_BENY = process.env.REACT_APP_AREAS_BENY;

const Header = () => {
  const { isAuth, user } = useContext(AuthContext);

  const [sidebarOpen,   setSidebarOpen]   = useState(false);
  const [modalPassword, setModalPassword] = useState(false);
  const [userMenuOpen,  setUserMenuOpen]  = useState(false);
  const [collapsed, setCollapsed] = useState(
    () => localStorage.getItem("sidebar-collapsed") === "true"
  );

  const currentPath = window.location.pathname;

  // Usuario de tienda (area Aby / Beny): solo ve la seccion Tiendas.
  const esDeTienda = !!user && (user.areas === AREAS_ABY || user.areas === AREAS_BENY);
  // Cobrador / edo. de cuenta de cliente: acceso minimo (sin menus).
  const soloCobranza = !!user && (user.menu_edoCta_Cliente || user.menu_cobradores);

  // ── Body classes ──────────────────────────────────────────────────────────
  useEffect(() => {
    if (!isAuth) return;
    document.body.classList.add("has-sidebar");
    if (collapsed) document.body.classList.add("sidebar-collapsed");
    return () => {
      document.body.classList.remove("has-sidebar");
      document.body.classList.remove("sidebar-collapsed");
    };
  }, [isAuth]); // eslint-disable-line

  if (!isAuth) return null;

  // ── Helpers ───────────────────────────────────────────────────────────────
  const hasPerm = (perm) => !!user[perm];

  const toggleCollapse = () => {
    const next = !collapsed;
    setCollapsed(next);
    localStorage.setItem("sidebar-collapsed", next);
    if (next) {
      document.body.classList.add("sidebar-collapsed");
      setUserMenuOpen(false);
    } else {
      document.body.classList.remove("sidebar-collapsed");
    }
  };

  return (
    <>
      {/* ── Mobile top bar ──────────────────────────────────────────────── */}
      <div className="sidebar-topbar d-lg-none">
        <button className="sidebar-toggle" onClick={() => setSidebarOpen(!sidebarOpen)}>
          <IcMenu />
        </button>
        <a href="/Inicio">
          <img src={process.env.PUBLIC_URL + "/logoInstitucion.png"} height="34" alt="logo" />
        </a>
      </div>

      {/* ── Mobile overlay ──────────────────────────────────────────────── */}
      {sidebarOpen && (
        <div className="sidebar-overlay" onClick={() => setSidebarOpen(false)} />
      )}

      {/* ── Sidebar ─────────────────────────────────────────────────────── */}
      <aside
        className={[
          "app-sidebar",
          sidebarOpen ? "open"      : "",
          collapsed   ? "collapsed" : "",
        ].filter(Boolean).join(" ")}
      >
        {/* Brand */}
        <div className="sidebar-brand">
          <a href="/Inicio" className="sidebar-logo-link">
            <img
              src={process.env.PUBLIC_URL + "/logoInstitucion.png"}
              alt="logo"
              style={{ maxHeight: 44, width: "auto" }}
            />
          </a>
          <button
            className="sidebar-collapse-btn"
            onClick={toggleCollapse}
            title={collapsed ? "Expandir" : "Comprimir"}
          >
            {collapsed ? <IcChevR /> : <IcChevL />}
          </button>
        </div>

        {/* Nav */}
        <nav className="sidebar-nav">
          {soloCobranza
            ? null
            : NAV_SECTIONS.map((sec) => {
                // Los usuarios de tienda solo ven la opcion Tiendas
                const visibleItems = sec.items.filter((i) =>
                  esDeTienda ? i.perm === "menuTiendas" && hasPerm(i.perm) : hasPerm(i.perm)
                );
                if (visibleItems.length === 0) return null;

                return (
                  <div key={sec.section} className="sidebar-section-group">
                    <div className="sidebar-section">{sec.section}</div>

                    {visibleItems.map((item) => {
                      const isActive = currentPath === item.href;
                      return (
                        <a
                          key={item.href}
                          href={item.href}
                          className={`sidebar-item${isActive ? " active" : ""}`}
                          title={collapsed ? item.label : ""}
                        >
                          {item.icon}
                          <span className="sidebar-label">{item.label}</span>
                        </a>
                      );
                    })}
                  </div>
                );
              })}
        </nav>

        {/* User footer */}
        <div className="sidebar-footer">
          <div
            className="sidebar-item"
            onClick={() => !collapsed && setUserMenuOpen(!userMenuOpen)}
            title={collapsed ? (user.nombre || user.email || "Usuario") : ""}
            style={{ justifyContent: collapsed ? "center" : "space-between" }}
          >
            <div style={{ display: "flex", alignItems: "center", gap: 11 }}>
              <IcUserCircle />
              <span className="sidebar-label" style={{ fontSize: "0.78rem" }}>
                {user.nombre || user.email || "Usuario"}
              </span>
            </div>
            {!collapsed && (
              userMenuOpen ? <IcChevD /> : <IcChevU />
            )}
          </div>

          {userMenuOpen && !collapsed && (
            <div className="sidebar-submenu">
              <div
                className="sidebar-item sidebar-item-sm"
                onClick={() => { setModalPassword(true); setUserMenuOpen(false); }}
              >
                <IcLock />
                <span>Cambiar contraseña</span>
              </div>
              <a href="/Logout" className="sidebar-item sidebar-item-sm" style={{ color: "#f87171" }}>
                <IcSignOut />
                <span>Cerrar sesión</span>
              </a>
            </div>
          )}
        </div>
      </aside>

      {/* ── Password modal ───────────────────────────────────────────────── */}
      <Modal size="sm" isOpen={modalPassword} toggle={() => setModalPassword(false)}>
        <ModalHeader toggle={() => setModalPassword(false)}>
          Cambio de contraseña
        </ModalHeader>
        <ModalBody>
          <Password />
        </ModalBody>
      </Modal>
    </>
  );
};

export default Header;
